webpackJsonp([153935816800649],{

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getClassName2 = __webpack_require__(12);
	
	var _getClassName3 = _interopRequireDefault(_getClassName2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _responsive = __webpack_require__(115);
	
	var _helpers = __webpack_require__(16);
	
	__webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _styleModuleImportMap = {
	  './TierBlockTitle.module.scss': {
	    'titles': 'src-components-TierBlockTitle----TierBlockTitle-module---titles---3jlhX',
	    'titleBlock': 'src-components-TierBlockTitle----TierBlockTitle-module---titleBlock---2Y5pX',
	    'titleWrapper': 'src-components-TierBlockTitle----TierBlockTitle-module---titleWrapper---3Dd1G',
	    'preTitle': 'src-components-TierBlockTitle----TierBlockTitle-module---preTitle---1WWX1',
	    'title': 'src-components-TierBlockTitle----TierBlockTitle-module---title----3PAL',
	    'dNone': 'src-components-TierBlockTitle----TierBlockTitle-module---dNone---2mUby'
	  }
	};
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TierBlockTitle = function (_Component) {
	  _inherits(TierBlockTitle, _Component);
	
	  function TierBlockTitle() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TierBlockTitle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      responsiveView: false,
	      desktop: false,
	      spacer: 17,
	      offset: 10,
	      offsetPretitle: 4
	    }, _this.resize = function () {
	      var responsiveView = window.innerWidth < _responsive.MOBILE;
	      var desktopView = window.innerWidth < _responsive.LARGEDESKTOP;
	
	      _this.setState({
	        responsiveView: responsiveView,
	        desktopView: desktopView
	      });
	
	      if (desktopView) {
	        _this.setState({
	          spacer: 12,
	          offset: 10,
	          offsetPretitle: 7
	        });
	      } else {
	        _this.setState({
	          spacer: 17,
	          offset: 10,
	          offsetPretitle: 4
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TierBlockTitle.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.resize);
	    this.resize();
	  };
	
	  TierBlockTitle.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', function () {});
	  };
	
	  TierBlockTitle.prototype.render = function render() {
	    var _props = this.props,
	        titles = _props.titles,
	        preTitle = _props.preTitle,
	        withAnimation = _props.withAnimation,
	        wrapTitleAndPreTitleInH1 = _props.wrapTitleAndPreTitleInH1;
	    var _state = this.state,
	        responsiveView = _state.responsiveView,
	        spacer = _state.spacer,
	        offset = _state.offset,
	        offsetPretitle = _state.offsetPretitle;
	
	
	    var TagName = wrapTitleAndPreTitleInH1 ? 'h1' : 'span';
	
	    return _react2.default.createElement(
	      TagName,
	      { className: 'src-components-TierBlockTitle----TierBlockTitle-module---titles---3jlhX' },
	      (0, _helpers.indexMap)(function (title, index) {
	        var isPreTitle = index === 0 && preTitle;
	        var style = {};
	
	        if (!responsiveView) {
	          style.marginLeft = (titles.length - 1 - index) * spacer + (isPreTitle ? offsetPretitle : offset);
	        }
	
	        return _react2.default.createElement(
	          'span',
	          {
	            style: style,
	            key: index,
	            className: ((0, _classnames2.default)('delay-' + index * 100 + 'ms', {
	              animated: withAnimation
	            }) ? (0, _classnames2.default)('delay-' + index * 100 + 'ms', { animated: withAnimation }) + ' ' : '') + 'src-components-TierBlockTitle----TierBlockTitle-module---titleBlock---2Y5pX',
	            'data-animation': 'fadeInLeft'
	          },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _getClassName3.default)((0, _classnames2.default)('titleWrapper', { preTitle: isPreTitle }), _styleModuleImportMap)
	            },
	            _react2.default.createElement(
	              'span',
	              { key: index, className: (0, _getClassName3.default)((0, _classnames2.default)('title', { preTitle: isPreTitle }), _styleModuleImportMap)
	              },
	              title,
	              _react2.default.createElement(
	                'span',
	                { className: 'src-components-TierBlockTitle----TierBlockTitle-module---dNone---2mUby' },
	                '\xA0'
	              )
	            )
	          )
	        );
	      }, titles)
	    );
	  };
	
	  return TierBlockTitle;
	}(_react.Component);
	
	TierBlockTitle.propTypes = {
	  titles: _propTypes2.default.array,
	  preTitle: _propTypes2.default.bool,
	  withAnimation: _propTypes2.default.bool
	};
	
	TierBlockTitle.defaultProps = {
	  titles: [],
	  preTitle: false,
	  withAnimation: false
	};
	
	exports.default = TierBlockTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"titles":"src-components-TierBlockTitle----TierBlockTitle-module---titles---3jlhX","titleBlock":"src-components-TierBlockTitle----TierBlockTitle-module---titleBlock---2Y5pX","titleWrapper":"src-components-TierBlockTitle----TierBlockTitle-module---titleWrapper---3Dd1G","preTitle":"src-components-TierBlockTitle----TierBlockTitle-module---preTitle---1WWX1","title":"src-components-TierBlockTitle----TierBlockTitle-module---title----3PAL","dNone":"src-components-TierBlockTitle----TierBlockTitle-module---dNone---2mUby"};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TierBlockTitle = __webpack_require__(175);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TierBlockTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var MOBILE = exports.MOBILE = 600;
	var TABLET = exports.TABLET = 800;
	var DESKTOP = exports.DESKTOP = 1000;
	var LARGEDESKTOP = exports.LARGEDESKTOP = 1200;

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _helpers = __webpack_require__(16);
	
	var _PageWrap = __webpack_require__(24);
	
	var _PageWrap2 = _interopRequireDefault(_PageWrap);
	
	var _Markdown = __webpack_require__(68);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _TierBlockTitle = __webpack_require__(176);
	
	var _TierBlockTitle2 = _interopRequireDefault(_TierBlockTitle);
	
	var _routes = __webpack_require__(17);
	
	var _RenderHireProductLink = __webpack_require__(275);
	
	__webpack_require__(1215);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderProducts = (0, _helpers.indexMap)(function (product, index) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-containers-CaseStudy----CaseStudy-module---productLink---2bY62', key: index },
	    R.equals(R.path(['template', '0', '__typename'], product), 'ContentfulProductTemplate') ? _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: (0, _routes.productRoute)((0, _RenderHireProductLink.renderHireProductLink)(R.propOr('/', 'slug', product), R.path(['template', '0', 'category'], product)))
	      },
	      R.path(['template', '0', 'shortName'], product)
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: (0, _routes.pageRoute)(R.propOr('/', 'slug', product)) },
	      R.prop('title', product)
	    )
	  );
	});
	
	var CaseStudy = function CaseStudy(_ref) {
	  var caseStudy = _ref.caseStudy;
	
	  var getTitles = R.pipe(R.propOr('', 'title'), R.split('|'));
	  var titles = getTitles(caseStudy);
	  var bgUrl = R.path(['image', 'resize', 'src'], caseStudy);
	  var intro = R.path(['intro', 'intro'], caseStudy);
	  var products = R.propOr([], 'products', caseStudy);
	  var content = R.prop('content', caseStudy);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'section',
	      { style: { backgroundImage: 'url(' + bgUrl + ')' }, className: 'src-containers-CaseStudy----CaseStudy-module---hero---1T8yt' },
	      _react2.default.createElement(
	        _PageWrap2.default,
	        null,
	        R.not(R.isEmpty(titles)) && _react2.default.createElement(_TierBlockTitle2.default, { titles: titles, preTitle: true })
	      )
	    ),
	    _react2.default.createElement(
	      _PageWrap2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'src-containers-CaseStudy----CaseStudy-module---case-study---2p7Bi' },
	        intro && _react2.default.createElement(
	          'div',
	          { className: 'src-containers-CaseStudy----CaseStudy-module---intro---1ApnA' },
	          intro
	        ),
	        R.not(R.isEmpty(products)) && _react2.default.createElement(
	          'div',
	          { className: 'src-containers-CaseStudy----CaseStudy-module---products---2mnP-' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'src-containers-CaseStudy----CaseStudy-module---heading---1PnAv' },
	            'Products'
	          ),
	          renderProducts(products)
	        ),
	        content && _react2.default.createElement(
	          'div',
	          { className: 'src-containers-CaseStudy----CaseStudy-module---content---1gy0h' },
	          _react2.default.createElement(_Markdown2.default, { content: content })
	        )
	      )
	    )
	  );
	};
	
	CaseStudy.propTypes = {
	  caseStudy: _propTypes2.default.object.isRequired
	};
	
	exports.default = CaseStudy;
	module.exports = exports['default'];

/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hero":"src-containers-CaseStudy----CaseStudy-module---hero---1T8yt","case-study":"src-containers-CaseStudy----CaseStudy-module---case-study---2p7Bi","heading":"src-containers-CaseStudy----CaseStudy-module---heading---1PnAv","intro":"src-containers-CaseStudy----CaseStudy-module---intro---1ApnA","products":"src-containers-CaseStudy----CaseStudy-module---products---2mnP-","productLink":"src-containers-CaseStudy----CaseStudy-module---productLink---2bY62","content":"src-containers-CaseStudy----CaseStudy-module---content---1gy0h"};

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CaseStudy = __webpack_require__(850);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CaseStudy).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _Seo = __webpack_require__(35);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _CaseStudy = __webpack_require__(851);
	
	var _CaseStudy2 = _interopRequireDefault(_CaseStudy);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudyPage = function CaseStudyPage(_ref) {
	  var data = _ref.data;
	
	  var metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data);
	  var metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data);
	  var canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data);
	  var caseStudy = R.pathOr('', ['contentfulPage', 'template', '0'], data);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: metaTitle,
	      canonicalUrl: canonicalUrl,
	      description: metaDescription
	    }),
	    caseStudy && _react2.default.createElement(_CaseStudy2.default, { caseStudy: caseStudy })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = CaseStudyPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-case-study-js-8b662da4281f8c722896.js